module.exports = __webpack_public_path__ + "img/wired_access_button.94ba2a4b.jpg";